<template>
  <v-card
    class="d-flex flex-column justify-center align-center mr-3 card-thumbnail"
    height="92px"
  >
    <slot> </slot>
    <template v-if="!loading">
      <div style="position: absolute">
        <div
          class="d-flex justify-center align-center px-3"
          style="margin-bottom: 2px; height: 28px"
        >
          <simple-svg
            :src="require('@/assets/thumbUploadIcon.svg')"
            width="16px"
            height="16px"
          />
          <span
            class="text-caption text-center font-weight-medium primary--text font-weight-medium ml-2"
          >
            {{ $t('message.pages.video.thumbUpload') }}
          </span>
        </div>
        <div class="px-3 text-center">
          <span
            class="text-caption font-weight-medium font-weight-regular neutral--text text--lighten-5"
          >
            {{ $t('message.pages.video.thumbnails.thumbLimit') }}
          </span>
        </div>
      </div>
    </template>
    <v-progress-circular
      v-else
      :size="22"
      width="3"
      color="primary"
      indeterminate
    ></v-progress-circular>
  </v-card>
</template>

<script>
export default {
  name: 'sendThumbCard',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.card-thumbnail {
  border: 2px dashed #d0d1d9 !important;
  box-shadow: none !important;
  border-radius: 4px;
  padding: 12px 16px;
  min-width: 150px;
  max-width: 150px;
}

.card-thumbnail .v-icon.v-icon::after {
  background-color: transparent !important;
}

.card-thumbnail .v-icon {
  width: 150px !important;
  height: 92px !important;
  z-index: 2;
}

.card-thumbnail .v-icon:before {
  margin-top: -25px !important;
}

.card-thumbnail .v-input__icon {
  width: 150px !important;
  height: 100%;
  z-index: 2;
  opacity: 0;
}

.card-thumbnail .v-input {
  padding: 0 !important;
}

.card-thumbnail .v-input__prepend-outer {
  margin-right: 0 !important;
}
</style>
